<p class="p-0 mb-2 text-center text-md-left">
  <button [attr.aria-label]="ariaLabel" [attr.data-e2e]="e2e + '-button'" [ngClass]="['btn', 'btn-' + style]" (click)="login.emit()">
    {{ i18nPath + '.label' | translate }}
  </button>
</p>

<p class="text-center text-md-left d-flex justify-content-around d-md-block justify-content-md-left p-0 m-0">
  <a
    class="o-link-arrow p-0"
    [attr.data-e2e]="e2e + '-find-identifier'"
    [href]="i18nPath + '.identifier.references.0.linkWeb.browser' | translate"
    (click)="findIdentifier.emit()"
  >
    {{ i18nPath + '.identifier.label' | translate }}
  </a>
</p>
